import { Select as Select_ } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { DownIcons } from '@mybridge/icons';
import { ArrowDownSelect, ChevronDownNew } from '@mybridge/icons';
import { AccordionIcon } from '@chakra-ui/icons';
export const Select = forwardRef(({ ...props }, ref) => {
  return (
    <Select_
      _invalid={{ borderColor: 'brandGray.100 !important' }}
      icon={
        <ChevronDownNew  size="md"/>
     
          }
      ref={ref}
      {...props}
    >
      {props?.children}
    </Select_>
  );
});
